import { CircularProgress } from '@mui/material';
import { PermissionEnum } from '@thro-types/access-handler';
import { User } from '@thro-types/users';

import { useState, ReactNode, useLayoutEffect } from 'react';

import { AuthorRole } from 'types/AppTypes';

import AuthContext from './AuthContext';

interface Props {
  children: ReactNode;
  userData: { currentUser: User };
  authorRolesData: { getAuthors: AuthorRole[] };
  permissionsData: { getUserPermission: PermissionEnum[] };
}

export const AuthProvider = ({ children, userData, authorRolesData, permissionsData }: Props) => {
  const [user, setUser] = useState<User | null>(null);
  const [authorRoles, setAuthorRoles] = useState<AuthorRole[]>([]);
  const [permissions, setPermissions] = useState<PermissionEnum[]>([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    if (!userData || !permissionsData || !authorRolesData) {
      setLoading(false);
      return;
    }

    setUser(userData.currentUser);
    setAuthorRoles(authorRolesData.getAuthors);
    setPermissions(permissionsData.getUserPermission);
    setLoading(false);
  }, [authorRolesData, permissionsData, userData]);

  if (loading) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, authorRoles, permissions }}>
      {children}
    </AuthContext.Provider>
  );
};
